import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrab = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 12.8488L7.75001 4.6216M14.75 12.8488V7.5253M14.75 12.8488L11.25 14.75L7.75001 12.8488M0.75 12.8488L7.75001 4.6216M0.75 12.8488L0.750026 7.5253M0.75 12.8488L4.25 14.75L7.75001 12.8488M7.75001 12.8488L7.75001 4.6216M0.750026 7.5253L0.750026 0.75L6.25 0.75001L3.25 3.55001V5.88334L0.750026 7.5253ZM14.75 7.5253L14.75 0.75H9.75L12.25 3.55001L12.25 5.41667L14.75 7.5253Z",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgCrab;
